import React from "react";
import { useTranslation, Trans } from "react-i18next";

type PatientInfo = {
  firstName: string;
  lastName: string;
  email: string;
};
type SuccessSubmitMsgProps = {
  patientInfo: PatientInfo;
};

const SuccessSubmitMsg = ({ patientInfo }: SuccessSubmitMsgProps) => {
  const { t } = useTranslation(["common"]);

  const { firstName, lastName, email } = patientInfo;

  return (
    <div>
      <h1 className="success_title">{t("inbox.success_title")}</h1>
      <p className="success_msg">
        <Trans
          i18nKey={"common:inbox.success_msg"}
          values={{
            firstName: firstName || "",
            lastName: lastName || "",
            email,
          }}
          components={{ span: <span />, br: <br /> }}
        />
      </p>
    </div>
  );
};

export default SuccessSubmitMsg;
